export enum Region {
  CN = 'cn',
  HK = 'hk'
}
